import React from 'react'
import { IconButton } from 'foundations-library/components'
/**
 *
 */
const DropdownButton = (props): JSX.Element => {
    return <IconButton variant='icon' name="more-vert" size='medium' data-button="options" color="neutral" {...props} />
}

export default DropdownButton
